var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRephrasePnc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.875C3.75 6.70924 3.81585 6.55027 3.93306 6.43306C4.05027 6.31585 4.20924 6.25 4.375 6.25H8.125C8.29076 6.25 8.44973 6.31585 8.56694 6.43306C8.68415 6.55027 8.75 6.70924 8.75 6.875C8.75 7.04076 8.68415 7.19973 8.56694 7.31694C8.44973 7.43415 8.29076 7.5 8.125 7.5H4.375C4.20924 7.5 4.05027 7.43415 3.93306 7.31694C3.81585 7.19973 3.75 7.04076 3.75 6.875ZM4.375 8.75C4.20924 8.75 4.05027 8.81585 3.93306 8.93306C3.81585 9.05027 3.75 9.20924 3.75 9.375C3.75 9.54076 3.81585 9.69973 3.93306 9.81694C4.05027 9.93415 4.20924 10 4.375 10H11.1788L12.2787 8.89875C12.166 8.80294 12.0229 8.75023 11.875 8.75H4.375ZM16.25 6.25375V6.25C16.25 5.91848 16.1183 5.60054 15.8839 5.36612C15.6495 5.1317 15.3315 5 15 5H2.5C2.16848 5 1.85054 5.1317 1.61612 5.36612C1.3817 5.60054 1.25 5.91848 1.25 6.25V13.75C1.25 14.0815 1.3817 14.3995 1.61612 14.6339C1.85054 14.8683 2.16848 15 2.5 15H7.19375C7.17411 15.0641 7.15618 15.1287 7.14 15.1937L6.875 16.25H2.5C1.83696 16.25 1.20107 15.9866 0.732233 15.5178C0.263392 15.0489 0 14.413 0 13.75V6.25C0 5.58696 0.263392 4.95107 0.732233 4.48223C1.20107 4.01339 1.83696 3.75 2.5 3.75H15C15.663 3.75 16.2989 4.01339 16.7678 4.48223C17.2366 4.95107 17.5 5.58696 17.5 6.25V6.4175C17.0961 6.29033 16.673 6.23491 16.25 6.25375ZM9.78 11.3988L8.67875 12.5H4.375C4.20924 12.5 4.05027 12.4342 3.93306 12.3169C3.81585 12.1997 3.75 12.0408 3.75 11.875C3.75 11.7092 3.81585 11.5503 3.93306 11.4331C4.05027 11.3158 4.20924 11.25 4.375 11.25H9.375C9.52875 11.25 9.67 11.3063 9.78 11.3988Z",
    fill: "url(#paint0_linear_33_15679)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 17.5V14.6429L15.8929 7.5L18.75 10.3571L11.6071 17.5H8.75Z",
    stroke: "url(#paint1_linear_33_15679)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.64453L16.6071 12.5017",
    stroke: "url(#paint2_linear_33_15679)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_15679",
    x1: 8.75,
    y1: 3.75,
    x2: 8.75,
    y2: 16.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_15679",
    x1: 13.75,
    y1: 7.5,
    x2: 13.75,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_15679",
    x1: 15.1786,
    y1: 9.64453,
    x2: 15.1786,
    y2: 12.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRephrasePnc);
export default __webpack_public_path__ + "static/media/rephrasePnc.60f56a095841434072add6444769cb9d.svg";
export { ForwardRef as ReactComponent };